module.exports = __webpack_public_path__ + "static/media/download.89c0240c.png";